import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function ProvisionLocations() {
  return (
    <Page
      title='Provision Locations'
      breadcrumbs={[
        {
          label: 'Global Settings',
        },
        {
          label: 'Provision Locations',
        },
      ]}
    >
      <Container>TODO</Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/global-settings/provision-locations',
  component: ProvisionLocations,
  type: 'auth',
});
